import { Component, Input } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "@mhe/ngx-shared/tooltip";
import * as i2 from "@mhe/ngx-shared/toggletip";
import * as i3 from "@angular/common";
import * as i4 from "@mhe/ngx-shared/translate";
/**
 * @deprecated since version 9.0
 */
export class A11yTooltipComponent {
    constructor() {
        this.placement = 'right';
        this.disableTooltip = false;
    }
    onToggletipHidden(tooltipType) {
        if (tooltipType === 'ToggletipDirective') {
            this.disableTooltip = false;
        }
    }
    onToggletipShown(tooltipType) {
        if (tooltipType === 'ToggletipDirective') {
            this.disableTooltip = true;
        }
    }
}
A11yTooltipComponent.ɵfac = function A11yTooltipComponent_Factory(t) { return new (t || A11yTooltipComponent)(); };
A11yTooltipComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: A11yTooltipComponent, selectors: [["mhe-a11y-tooltip"]], inputs: { text: "text", placement: "placement" }, decls: 5, vars: 9, consts: [[1, "a11y-tooltip-container"], [1, "tooltip-button", 3, "mheTooltip", "disableTooltip", "mheToggletip", "placement", "hidden", "shown"], [1, "dpg-icon", "dpg-icon-system-alert-info"]], template: function A11yTooltipComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0)(1, "button", 1);
        i0.ɵɵlistener("hidden", function A11yTooltipComponent_Template_button_hidden_1_listener($event) { return ctx.onToggletipHidden($event); })("shown", function A11yTooltipComponent_Template_button_shown_1_listener($event) { return ctx.onToggletipShown($event); });
        i0.ɵɵpipe(2, "async");
        i0.ɵɵpipe(3, "mheTranslate");
        i0.ɵɵelement(4, "i", 2);
        i0.ɵɵelementEnd()();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("mheTooltip", "instructions")("disableTooltip", ctx.disableTooltip)("mheToggletip", ctx.text)("placement", ctx.placement);
        i0.ɵɵattribute("aria-label", i0.ɵɵpipeBind1(2, 5, i0.ɵɵpipeBind1(3, 7, "ngx-shared-instructions-toggle-tip")));
    } }, dependencies: [i1.TooltipDirective, i2.ToggletipDirective, i3.AsyncPipe, i4.TranslatePipe], styles: [".tooltip-button[_ngcontent-%COMP%]{background:rgba(0,0,0,0);border:none;cursor:pointer;height:25px;width:26px;position:relative}.tooltip-button[_ngcontent-%COMP%]:focus{position:relative;box-shadow:none;color:#006a7c;outline:1px solid #006a7c}.tooltip-button[_ngcontent-%COMP%]   i.dpg-icon[_ngcontent-%COMP%]{position:absolute;top:50%;left:50%;transform:translate(-50%, -50%)}\n"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(A11yTooltipComponent, [{
        type: Component,
        args: [{ selector: 'mhe-a11y-tooltip', template: "<div class=\"a11y-tooltip-container\">\n  <button\n    [attr.aria-label]=\"'ngx-shared-instructions-toggle-tip' | mheTranslate | async\"\n    class=\"tooltip-button\"\n    [mheTooltip]=\"'instructions'\"\n    [disableTooltip]=\"disableTooltip\"\n    [mheToggletip]=\"text\"\n    (hidden)=\"onToggletipHidden($event)\"\n    (shown)=\"onToggletipShown($event)\"\n    [placement]=\"placement\"\n  >\n    <i class=\"dpg-icon dpg-icon-system-alert-info\"></i>\n  </button>\n</div>\n", styles: [".tooltip-button{background:rgba(0,0,0,0);border:none;cursor:pointer;height:25px;width:26px;position:relative}.tooltip-button:focus{position:relative;box-shadow:none;color:#006a7c;outline:1px solid #006a7c}.tooltip-button i.dpg-icon{position:absolute;top:50%;left:50%;transform:translate(-50%, -50%)}/*# sourceMappingURL=a11y-tooltip.component.css.map */\n"] }]
    }], null, { text: [{
            type: Input
        }], placement: [{
            type: Input
        }] }); })();
